/*
 * js module for the DetailHeaderActionBar control
*/

rs.module("ui/controls/list/detailheaderactionbar",

    [],

    function () {

        var _headerActions;
        var _clickedAction;

        //
        // Initialize
        //
        function initialize(headerActionBarSelector) {
            _headerActions = $.js(headerActionBarSelector).find(".list-detail__header-action");

            _headerActions.on("click enterpressed", function (e) {
                _clickedAction = $(this);
            });
        }

        //
        // Callback function for getting the download-related callbacks
        // 
        function getDownloadOptions() {
            return {
                onstart: function () {
                    _clickedAction.addClass("_downloading");
                },
                oncomplete: function () {
                    _clickedAction.removeClass("_downloading");
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            getDownloadOptions: getDownloadOptions
        };

        return exports;
    }
);